import { FormattedMessage } from 'react-intl';

const NotApplicable = () => (
    <span className={'text-color-gray'}>
        <FormattedMessage id={'intl-msg:maintenanceHistory.notApplicable'} />
    </span>
);

export default NotApplicable;
